import { Stack } from '@mui/material';
import NewsCardSkeleton from './NewsCardSkeleton';

interface NewsArticleListSkeletonProps {
  limit?: number;
}

export default function NewsArticleListSkeleton({
  limit = 10,
}: Readonly<NewsArticleListSkeletonProps>) {
  const skeletons = Array.from({ length: limit }, (_, index) => (
    <NewsCardSkeleton key={'news-card-skeleton-' + index} />
  ));
  return (
    <Stack
      direction='column'
      sx={{
        gap: 1,
      }}
    >
      {skeletons}
    </Stack>
  );
}
